import { render, staticRenderFns } from "./ApplicationOrganizationTransfer.vue?vue&type=template&id=54e5df72&scoped=true&"
import script from "./ApplicationOrganizationTransfer.vue?vue&type=script&lang=js&"
export * from "./ApplicationOrganizationTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationOrganizationTransfer.vue?vue&type=style&index=0&id=54e5df72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e5df72",
  null
  
)

export default component.exports